import {
  ApplicationRef,
  ComponentRef,
} from '@angular/core';
import { ToastComponent } from './toast.component';

export class ToastRef {
  constructor(
    private componentRef: ComponentRef<ToastComponent>,
    private appRef: ApplicationRef
  ) {}

  close() {
    this.appRef.detachView(this.componentRef.hostView);
    this.componentRef.destroy();
  }
}
